import JSZip from 'jszip'

export const isFileDefined = (f: File | undefined): f is File => f !== undefined

export const imagesFromZip = async (file: File): Promise<File[]> => {
    if (!file.name.endsWith('.zip')) {
        return [file]
    }

    const zip = new JSZip()
    const content = await zip.loadAsync(file)

    const extractedFiles = await Promise.all(
        Object.keys(content.files).map(filename => extractJpegFromZIP(content, filename))
    )

    return extractedFiles.filter(isFileDefined)
}

export const extractJpegFromZIP = async (
    zipContent: JSZip,
    filename: string
): Promise<File | undefined> => {
    const zipEntry = zipContent.files[filename]
    const isJpeg = /\.(jpe?g)$/i.test(filename)

    if (zipEntry.dir || !isJpeg) {
        return
    }

    const blob = await zipEntry.async('blob')
    const extractedFile = new File([blob], filename, {
        type: 'image/jpg',
    })

    return extractedFile
}
